import React from 'react'

const money = amount => `GBP ${(amount / 100).toFixed(2)}`

export default function VatIntakeTotals({ intake }) {
  if (intake.loading) return <p role="status">Checking service prices...</p>
  if (intake.error) return <div role="alert"><p>{intake.error}</p><button type="button" className="btn btn-ghost" onClick={intake.refresh}>Refresh prices</button></div>
  if (!intake.prices) return null
  if (intake.enquiry) return <section aria-label="Assessment pricing" className="alert alert-info">
    Assessment enquiry · price to be confirmed. Save this job without a final charge. The owner must review each service price and VAT treatment before a quote or agreement. No VAT sale or tax point is recorded at intake.
  </section>
  const { tax, configuration } = intake.prices
  const registered = configuration.registration === 'registered'
  return <section aria-label="Reviewed service totals" style={{ padding: 12, margin: '12px 0', border: '1px solid var(--border)', borderRadius: 8 }}>
    {tax.lines.map(line => <div className="detail-row" key={line.id}><span>{line.description}</span><strong>{money(line.gross_minor)}</strong></div>)}
    <div className="detail-row"><span>{registered ? 'Subtotal (excluding VAT)' : 'Subtotal'}</span><strong>{money(tax.net_minor)}</strong></div>
    <div className="detail-row"><span>{registered ? 'VAT' : 'VAT not charged — not VAT registered'}</span><strong>{money(tax.tax_minor)}</strong></div>
    <div className="detail-row"><span>{registered ? 'Total (including VAT)' : 'Total'}</span><strong>{money(tax.gross_minor)}</strong></div>
    <p className="field-hint">Prices follow the workshop’s reviewed settings. Additional work needs its own reviewed quote.</p>
  </section>
}
